// extracted by mini-css-extract-plugin
module.exports = {"root":"RichText_root__Dlh5q","small":"RichText_small__hYWV4"};